import Axios from '@/axios'

/*业务平台管理*/

// 创建业务平台：web:app:create
export const AppCreate = data => {
  return Axios({
    url: '/device-manager/web-api/app/create',
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除业务平台：web:app:delete
export const AppDelete = id => {
  return Axios({
    url: `/device-manager/web-api/app/delete/${id}`,
    method: 'POST',
    type: 'json'
  })
}
// 查询业务平台：web:app:index
export const AppIndex = data => {
  return Axios({
    url: '/device-manager/web-api/app/index',
    method: 'POST',
    type: 'json',
    data
  })
}
// 重置应用密钥：web:app:resetKey
export const AppResetKey = id => {
  return Axios({
    url: `/device-manager/web-api/app/resetKey/${id}`,
    method: 'POST',
    type: 'json'
  })
}
// 修改业务平台：web:app:update
export const AppUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/app/update/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}
